interface IsPatternMatchProps {
  pattern: string
  currentUrl: string
}

/**
 * 檢查路由是否為指定頁，或涵蓋指定頁底下所有路由
 */
export const isPatternMatch = (props: IsPatternMatchProps) => {
  const { pattern, currentUrl } = props
  const hasWildcard = pattern.endsWith('/*')
  const normalizedPattern = pattern.replace('/*', '')
  if (hasWildcard) {
    return currentUrl.startsWith(normalizedPattern)
  }
  else {
    return currentUrl === normalizedPattern
  }
}
